import React from 'react'
import VideoLightBox from '../../../VideoLightBox'

const DisplayVideoLightBox = props => {
  const {
    displayNull,
    selectedPart,
    showVideo,
    setShowVideo,
    productText,
    partsWithVideos,
    isBot,
  } = { ...props }
  return (
    <>
      {!displayNull && selectedPart && (
      <VideoLightBox
        isBot={isBot}
        key="videolbox"
        showVideo={showVideo}
        setShowVideo={setShowVideo}
        partText={productText}
        isPartHasVideo={partsWithVideos.includes(productText.toLowerCase())}
      />
      )}
    </>
  )
}

export default DisplayVideoLightBox
